import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import SuperAdminHeader from './SuperAdminHeader'
import EditBranch from './EditBranch'
import AssignBranch from './AssignBranch'
import { useNavigate } from 'react-router-dom'
import { FaBan, FaCheckCircle, FaEdit, FaTrash, FaTrashAlt } from 'react-icons/fa'

export default function AllAdmins() {
  
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const [admins, setAdmins] = useState([])
  const [selectedAdmin, setSelectedAdmin] = useState(null)

  const fetchAdmin = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_all_admins/`, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('Admin Res:', res)

      if(res.status === 200){
        setAdmins(res.data.data)
      }else{
        toast.error('Failed to fetch admins')
      }
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create branch'

      toast.error(message)
    }
  }

  useEffect(() => {
    fetchAdmin()
  },[token])
  console.log('Admins:', admins)

  const handleStatus = async(id) => {
    try{
      const res = await axios.put(`${config.baseurl}activate_admin/${id}/`,{},{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success(res.data.message)
      await fetchAdmin()
    } catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to Update admin status'

      toast.error(message)
    }
  }

  const handleDelete = async(id) => {
    console.log('Admin Id:', id)

    if(!id){
      toast.error('Invalid Branch id')
      return
    }

    try{
      const res = await axios.delete(`${config.baseurl}delete_admin/${id}/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success('Admin Deleted Successfully')
      await fetchAdmin()
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create branch'

      toast.error(message)
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <SuperAdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL ADMINS
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all registered admins in one place.
        </p>
      </div>

      <div className='max-w-7xl mx-auto px-6 pb-10'>
        <div className='bg-white rounded-lg shadow-sm border border-slate-300 overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='w-full table-auto'>
              <thead>
                <tr className='text-center border-b border-slate-300'>
                  <th className='px-3 py-2 whitespace-nowrap'>No</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Admin Name</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Address</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Email</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Phone Number</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Actions</th>
                </tr>
              </thead>

              <tbody>
                {admins.length > 0 ? (
                  admins.map((item, index) => (
                    <tr
                      key={item.id}
                      className='text-center border-b border-b-slate-300'
                    >
                      <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.admin_name}</td>
                      <td className='px-3 py-2 max-w-[250px] break-words whitespace-normal'>{item.address}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.email}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.phone}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>
                        <div className='flex justify-center gap-3'>
                          <button
                            title='Edit'
                            onClick={() => {
                              setSelectedAdmin(item)
                              navigate(`/super_admin/edit_admin/${item.id}`)
                            }}
                            className='bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600'
                          >
                            <FaEdit/>
                          </button>

                          <button
                            title='Remove'
                            onClick={() => handleDelete(item.id)}
                            className='bg-slate-500 text-white px-4 py-2 rounded-lg hover:bg-slate-600'
                          >
                            <FaTrashAlt/>
                          </button>

                          <button
                            title={item.is_active ? 'Deactive' : 'Activate'}
                            onClick={() => handleStatus(item.id)}
                            className={`text-white px-4 p-2 rounded-lg ${
                              item.is_active
                                ? 'bg-red-500 hover:bg-red-600'
                                : 'bg-blue-500 hover:bg-blue-600'
                            }`}
                          >
                            {item.is_active ? <FaBan/> : <FaCheckCircle/>}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      className='text-center py-6'
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
